import {
  NotificationType,
  NotifyRequest,
} from "../interfaces/clientNotification";
import { fetchWithAuth } from "./fetchWithAuth";

const APP_URL = process.env.REACT_APP_APP_URL || "";
const DEV_APP_URL = process.env.REACT_APP_DEV_APP_URL || "";
const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";

const siteBaseUrl =
  window.location.hostname === "localhost"
    ? APP_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_APP_URL
      : DEV_APP_URL;

const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

// bulk notify clients
export const sendEmail = async (
  subject: string,
  message: string,
  denomination: string,
  clientStatus: string,
): Promise<{ success: boolean; count?: number }> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(`${apiBaseUrl}/api/email/SendEmail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ subject, message, denomination, clientStatus }),
  });

  const data = await response.json();

  if (!data.success) {
    console.log("Something went wrong while sending emails.");
  }

  return data;
};

// triggered by client
export const notifyAdminOfClientUpdate = async (
  clientID: number,
  message: string,
): Promise<{
  success: boolean;
  count?: number;
}> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/email/NotifyAdminOfClientUpdate?ClientID=${clientID}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ clientID, message }),
    },
  );

  const data = await response.json();

  if (!data.success) {
    console.log("Something went wrong while sending emails.");
  }

  return data;
};

export const sendNotifyClientEmail = async (
  request: NotifyRequest,
): Promise<{ success: boolean; error?: string }> => {
  try {
    if (!apiBaseUrl) {
      throw new Error("API URL is not defined");
    }

    if (request.type === NotificationType.Candidate) {
      request.baseUrl = `${siteBaseUrl}?portal=candidate&email=${encodeURIComponent(request.candidateEmail ? request.candidateEmail : "")}`;
    } else {
      request.baseUrl = `${siteBaseUrl}?portal=client`;
    }

    const response = await fetch(`${apiBaseUrl}/api/Email/NotifyClient`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      return { success: false, error: result.message || "Failed to notify." };
    }

    return { success: true };
  } catch (error: any) {
    console.error("Error sending notification:", error);
    return { success: false, error: error.message || "Unexpected error." };
  }
};
